import { Module } from "vuex";
import { StoreState } from "@/store/type";

import mutations from "./mutations";
import actions from "./actions";
import state from "./state";
import getters from "./getters";
import { IQuotationManagementState } from "@/core/interfaces/state/quotationManagmentState.interface";

const manageQuotationsModule: Module<IQuotationManagementState, StoreState> = {
  state,
  mutations,
  actions,
  getters,
};

export default manageQuotationsModule;
